<template>
  <div class="row my-2">
    <div class="col-lg-12">
      <div class="card" v-if="accountData.sessions_limit">
        <div class="card-header">
          <div class="row align-items-center">
            <div class="col-lg-6">
              <div class="cui__utils__heading mb-0">
                <strong>Total Packages</strong>
              </div>
              <div class="text-muted">
                {{ common.numberWithCommas(accountData.sessions_limit) }}
                {{ common.handlePaymentModelName(accountData.payment_model) }}
              </div>
            </div>
            <div class="col-lg-6 text-right"></div>
          </div>
        </div>
        <div class="card-body">
          <div class="row align-items-center">
            <div class="col-md-6">
              <div class="font-size-36 font-weight-bold text-dark mb-n2">
                {{
                  Math.floor(
                    (accountData.current_sessions * 100) /
                      accountData.sessions_limit
                  )
                }}<i class="fa fa-percent icon-large"></i>
              </div>
              <div class="">
                {{ common.numberWithCommas(accountData.current_sessions) }}
                {{ common.handlePaymentModelName(accountData.payment_model) }}
                consumed
              </div>
            </div>
            <div class="col-md-6 text-right">
              <div class="font-size-36 font-weight-bold text-dark mb-n2">
                {{
                  100 -
                  Math.floor(
                    (accountData.current_sessions * 100) /
                      accountData.sessions_limit
                  )
                }}<i class="fa fa-percent icon-large"></i>
              </div>
              <div class="">
                {{ common.numberWithCommas(accountData.sessions_remaining) }}
                {{ common.handlePaymentModelName(accountData.payment_model) }}
                remaining
              </div>
            </div>
          </div>
          <v-progress-linear
            :value="
              Math.floor(
                (accountData.current_sessions * 100) /
                  accountData.sessions_limit
              )
            "
            :show-info="false"
          />
        </div>
      </div>
    </div>
    <div class="col-lg-6"></div>
  </div>
</template>

<script>
import common from '@/utils/analytics/common'
export default {
  name: 'totalConsumption',
  props: {
    accountData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      common
    }
  }
}
</script>

<style src="@/assets/css/bs-helpers.css" lang="css" scoped/>
